import { create } from "zustand"

/** One stat cell from `segment_popup.columns` (API may send numeric `value`). */
export interface SegmentSheetColumn {
  /** Backend metric id (e.g. `winrate`); optional, used as React key when set. */
  key?: string
  name: string
  /** Display string (normalized in `parseSegmentSheetPayload`). */
  value: string
}

export interface SegmentSheetData {
  title: string
  segment: string
  /** Optional marketing campaign id from `segment_popup` API. */
  campaignId?: string
  columns: SegmentSheetColumn[]
  widget: {
    title: string
    content: string
    special_text: string
  }
  button_text: string
  button_url: string
}

interface SegmentSheetState {
  data: SegmentSheetData | null
  isOpened: boolean
  setIsOpened: (value: boolean) => void
  show: (data: SegmentSheetData) => void
  close: () => void
}

export const useSegmentSheetStore = create<SegmentSheetState>((set) => ({
  data: null,
  isOpened: false,
  setIsOpened: (value) => set({ isOpened: value }),
  show: (data) => {
    if (data == null) return
    set({ isOpened: true, data })
  },
  close: () => set({ isOpened: false }),
}))
